import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../../components/pagination'
import {Table, Button, Modal, Switch} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'
import moment from 'moment'

const storage = window.localStorage
const {confirm} = Modal

@inject('intelligentQueryStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null,
  }

  handleEdit = (record) => {
    this.setState({
      addModalVisible: true,
      record
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false,
      record: null,
    })
  }
  handleDel = (record) => {
    const {intelligentQueryStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        intelligentQueryStore.onSqlExampleDeleteAction({ids: [record?.id]})
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {intelligentQueryStore} = this.props
    intelligentQueryStore.onSqlExamplePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleChangeStatus = (record) => {
    const {intelligentQueryStore} = this.props
    intelligentQueryStore.onSqlExampleStatusAction({
      'enabled': record?.enabled,
      'id': record?.id,
    })
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {intelligentQueryStore, t} = this.props
    const {pageNo, pageSize, itemCount, sqlExampleList} = intelligentQueryStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(sqlExampleList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column width={150} title={t(`intelligentQuery.questionDesc`)} dataIndex="question" key="question" ellipsis={true}/>
          <Table.Column width={200} title={t(`intelligentQuery.sqlContent`)} dataIndex="description" key="description" ellipsis={true}/>
          <Table.Column width={80} title={t(`intelligentQuery.advancedApplication`)} dataIndex="advanced_application_name" key="advanced_application_name" ellipsis={true}/>
          <Table.Column width={80} title={t(`general.status`)} dataIndex="enabled" key="enabled"
            render={(text, record) => (
              <Switch
                checked={text}
                onChange={() => {}}
                onClick={(e) => {
                  this.handleChangeStatus({enabled: e, id: record.id})
                }}
                data-record-id={text}
              />
            )}
          />
          <Table.Column width={80} title={t(`general.createTime`)} dataIndex="create_time" key="create_time" ellipsis={true} render={(text, record) => (
            <>
              {moment(text).format('YYYY-MM-DD HH:mm:ss')}
            </>
          )}/>
          <Table.Column width={80} align="center" fixed="right" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
          record={this.state.record}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)